import type { ServerMessage } from "@utah-vr/shared";

export function connectLive(onMessage: (msg: ServerMessage) => void): WebSocket {
	const proto = location.protocol === "https:" ? "wss" : "ws";
	const ws = new WebSocket(`${proto}://${location.host}/ws/live-factory-status`);
	ws.addEventListener("message", (ev) => {
		try {
			onMessage(JSON.parse(ev.data) as ServerMessage);
		} catch (err) {
			console.warn("bad ws payload", err);
		}
	});
	ws.addEventListener("open", () => console.info("[ws] connected"));
	ws.addEventListener("close", () => console.info("[ws] closed"));
	return ws;
}
